import React, { useState, useEffect } from "react";
import { useEtatGlobal } from "../EtatGlobal.js";
import {
  X,
  FileText,
  AlertCircle,
  Loader2,
  Check,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import { authFetch } from '../../HttpClient';
import { useClients } from "../Portefeuille/useClients.js";
import { uploadFileToBlob } from "../../utils/uploadFileToBlob";

import { dialog } from "../../components/ui/Dialog";
import { normalizeText } from "../../utils/text.js";
const CreateTodo = ({ setShowAddDiv, fetchTodos }) => {
  const { utilisateur } = useEtatGlobal();
  // Liste déjà chargée et mise en cache à la connexion (React Query,
  // staleTime Infinity) — la recherche ci-dessous s'y fait en mémoire.
  const { data: clients = [] } = useClients();
  const [files, setFiles] = useState({
    bilanDocument: null,
    identityDocument: null,
    kbisDocument: null,
    statusDocument: null,
    pieceIdentite: null,
  });
  const [formData, setFormData] = useState({
    title: "",
    status: "",
    type: "",
    nomClient: "",
    clientId: "",
    // formLeadId: "",
    eventId: "",
    userIds: [],
    nature: "",
    dueDate: "",
    priority: "classique",
    commentaire: "",
    periodeMois: "",
  });

  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null);

  const [searchUser, setSearchUser] = useState("");
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [ChaqueAssocieDocument, setChaqueAssocieDocument] = useState(false);

  const handleSearchUser = (e) => {
    const q = e.target.value;
    setSearchUser(q);

    if (q.length < 2) {
      setUserSuggestions([]);
      return;
    }

    const filtered = allUsers.filter(
      (user) =>
        normalizeText(`${user.name} ${user.lastName}`).includes(
          normalizeText(q),
        ) && !formData.userIds.includes(user.id)
    );

    setUserSuggestions(filtered);
  };

  const selectUser = (user) => {
    if (!formData.userIds.includes(user.id)) {
      setFormData((prev) => ({
        ...prev,
        userIds: [...prev.userIds, user.id],
      }));
    }
    setSearchUser("");
    setUserSuggestions([]);
  };

  //   const [formLeads, setFormLeads] = useState([]);
  //   const [selectedLeadId, setSelectedLeadId] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [notifyByEmail, setNotifyByEmail] = useState(true);

  //   useEffect(() => {
  //     authFetch("https://backend-myalfa.vercel.app/api/formleads")
  //       .then((res) => res.json())
  //       .then((data) => {
  //         setFormLeads(data.data || []);
  //       })
  //       .catch((error) => {
  //         console.error("Erreur lors du chargement des leads :", error);
  //       });
  //   }, []);

  useEffect(() => {
    // Charger les utilisateurs pour userIds[]
    authFetch("https://backend-myalfa.vercel.app/api/users")
      .then((res) => res.json())
      .then((data) => setAllUsers(data))
      .catch((err) => console.error("Erreur chargement utilisateurs", err));
  }, []);

  //   const handleLeadSelect = (e) => {
  //     const selectedId = parseInt(e.target.value);
  //     setSelectedLeadId(selectedId || "");

  //     const selectedLead = formLeads.find((lead) => lead.id === selectedId);
  //     const nomComplet = selectedLead
  //       ? `${selectedLead.prenom} ${selectedLead.nom}`
  //       : "";

  //     console.log("Lead sélectionné ID :", selectedLeadId);

  //     setFormData((prev) => ({
  //       ...prev,
  //       formLeadId: selectedId || "",
  //       nomCompletLead: nomComplet, // <-- AJOUTÉ ICI
  //     }));
  //   };

  //   console.log("Lead sélectionné nom :", formData.nomCompletLead);

  const handleSearchClient = (e) => {
    const q = e.target.value;
    setSearchClient(q);
    if (q.length < 2) {
      setClientSuggestions([]);
      setSelectedClientId("");
      setFormData((prev) => ({
        ...prev,
        clientId: "",
      }));
      return;
    }
    // Filtre en mémoire sur la liste déjà en cache, au lieu d'un appel à
    // /api/clients/search à chaque frappe : la suggestion est instantanée.
    // Mêmes règles que l'endpoint remplacé (searchClientsByName) et que
    // SignModif/clientSearch.js : multi-mots, ordre indifférent, insensible
    // à la casse, 25 résultats au maximum.
    const terms = q.toLowerCase().split(/\s+/).filter(Boolean);
    setClientSuggestions(
      clients
        .filter((c) => terms.every((t) => (c.nom || "").toLowerCase().includes(t)))
        .slice(0, 25)
        .map((c) => ({ id: c.id, nom: c.nom }))
    );
  };

  const selectClient = (client) => {
    setSelectedClientId(client.id);
    setSearchClient(client.nom);
    setClientSuggestions([]);

    console.log("Client sélectionné nom :", searchClient);
    setFormData((prev) => ({
      ...prev,
      clientId: client.id,
      nomClient: client.nom, // Mettre à jour le nom du client dans formData
    }));

    console.log(" ---- ID Client sélectionné formData :", formData.clientId);
  };

  console.log("Client sélectionné nom :", formData.nomClient);

  useEffect(() => {
    const fetchClientDetails = async () => {
      if (!selectedClientId) return;

      try {
        const res = await authFetch(`https://backend-myalfa.vercel.app/api/clients/${selectedClientId}`
        );
        const data = await res.json();

        if (
          data &&
          data.nom &&
          data.formeSociale &&
          data.formeSociale.length > 0
        ) {
          setFormData((prev) => ({
            ...prev,
            nom_client: data.nom,
            forme_sociale: data.formeSociale[0],
          }));
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des détails du client :",
          error
        );
      }
    };
    console.log(" ---- ID Client sélectionné formData :", selectedClientId);

    fetchClientDetails();
  }, [selectedClientId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRemoveUser = (idToRemove) => {
    setFormData((prev) => ({
      ...prev,
      userIds: prev.userIds.filter((id) => id !== idToRemove),
    }));
  };

  const emailUsers = [
    ...allUsers
      .filter((user) => formData.userIds.includes(user.id))
      .map((user) => user.email),
    utilisateur.email,
  ];

  console.log("Liste des emails des utilisateurs sélectionnés :", emailUsers);

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: selectedFiles[0],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // =========================
      // FormData pour /api/todos
      // =========================
      const formDataToSend = new FormData();

      // Champs texte
      formDataToSend.append("title", formData.title);
      formDataToSend.append("status", formData.status);
      formDataToSend.append("type", formData.type);
      formDataToSend.append("nomClient", formData.nomClient || "");
      formDataToSend.append("clientId", formData.clientId || "");
      formDataToSend.append("nature", formData.type);
      formDataToSend.append("dueDate", formData.dueDate);
      formDataToSend.append("priority", formData.priority);
      formDataToSend.append("commentaire", formData.commentaire);
      if (formData.type === "TraitementComptablePreCompta") {
        formDataToSend.append("periodeMois", formData.periodeMois);
      }

      // userIds (important)
      formData.userIds.forEach((id) => {
        formDataToSend.append("userIds", id);
      });

      // =========================
      // FICHIERS — upload direct navigateur → Blob (contourne la limite
      // 4,5 Mo), avec une progression affichée pendant l'envoi.
      // =========================
      const fileEntries = Object.entries(files).filter(([, file]) => file);
      for (const [key, file] of fileEntries) {
        setUploadProgress(0);
        const url = await uploadFileToBlob(
          file,
          "https://backend-myalfa.vercel.app/api/todos/upload-token",
          ({ percentage }) => setUploadProgress(Math.round(percentage))
        );
        formDataToSend.append(`${key}Url`, url);
      }
      setUploadProgress(null);

      // =========================
      // API TODO (même URL)
      // =========================
      const response = await authFetch("https://backend-myalfa.vercel.app/api/todos",
        {
          method: "POST",
          body: formDataToSend, // ⚠️ PAS de headers ici
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la création du TODO.");
      }

      // =========================
      // API MAIL (inchangée)
      // =========================
      // Pour ce type, le backend envoie déjà son propre mail d'affectation
      // Traitements comptables (étape 2) — pas le mail générique de création
      // de tâche, qui n'aurait pas de sens ici.
      if (notifyByEmail && formData.type !== "TraitementComptablePreCompta") {
        await authFetch("https://backend-myalfa.vercel.app/api/mail-todo-create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: formData.title,
            status: formData.status,
            type: formData.type,
            nomClient: formData.nomClient || searchClient || "",
            dueDate: formData.dueDate,
            priority: formData.priority,
            emailUsers: emailUsers || [],
            commentaire: formData.commentaire,
          }),
        });
      }

      dialog.alert("TODO créé avec succès !");
      setShowAddDiv(false);
      await fetchTodos();
    } catch (err) {
      console.error(err);
      dialog.alert("Erreur création TODO");
    } finally {
      setUploadProgress(null);
      setLoading(false);
    }
  };

  const isFormInvalid =
    !formData.nomClient?.trim() ||
    !formData.userIds ||
    formData.userIds.length === 0 ||
    (formData.type === "TraitementComptablePreCompta" &&
      (!formData.clientId || !formData.periodeMois));

  return (
    <div className="overlayAC">
      <div className="inoverlayMS">
        <div className="flex flex-col flex-1 min-h-0">

          {/* En-tête */}
          <div className="flex items-center justify-between px-6 pt-4 pb-4 border-b border-slate-100 shrink-0">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-[#9B1B5D] flex items-center justify-center">
                <FileText className="w-4 h-4 text-white" />
              </div>
              <div>
                <h2 className="text-base font-bold text-slate-900 leading-tight">
                  Création de tâche
                </h2>
                <p className="text-xs text-slate-400">Associer à un client et des collaborateurs</p>
              </div>
            </div>
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setShowAddDiv(false); }}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Corps du formulaire */}
          <form
            className="flex-1 overflow-y-auto px-6 py-4 space-y-4"
            onSubmit={handleSubmit}
            encType="multipart/form-data"
          >
            {/* ── Informations essentielles ── */}
            {/* Pas d'overflow-hidden ici : il coupait les listes de suggestions
                (client, collaborateur) au bord du bloc ; l'en-tête porte
                lui-même ses coins arrondis. */}
            <div className="border border-slate-200 rounded-xl">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-slate-50 border-b border-slate-200 rounded-t-xl">
                <AlertCircle className="w-4 h-4 text-[#9B1B5D]" />
                <span className="text-sm font-semibold text-slate-700">Informations essentielles</span>
              </div>
              <div className="p-4 space-y-4">
                {/* Client */}
                <div className="relative w-full">
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Client</label>
                  <input
                    type="text"
                    value={searchClient}
                    onChange={handleSearchClient}
                    placeholder="Recherche client…"
                    autoComplete="off"
                    className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40 placeholder:text-slate-300"
                  />
                  {clientSuggestions.length > 0 && (
                    <ul className="absolute left-0 top-full mt-1 w-full max-h-60 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg z-20">
                      {clientSuggestions.map((client) => (
                        <li
                          key={client.id}
                          onClick={() => selectClient(client)}
                          className="cursor-pointer px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors border-b last:border-b-0"
                        >
                          {client.nom}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Date + Priorité */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-slate-500 mb-1">Date d'échéance</label>
                    <input
                      type="date"
                      name="dueDate"
                      value={formData.dueDate}
                      onChange={handleChange}
                      className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-slate-500 mb-1">Priorité</label>
                    <select
                      name="priority"
                      value={formData.priority}
                      onChange={handleChange}
                      className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40 text-slate-700"
                    >
                      <option value="classique">Classique</option>
                      <option value="élevée">Élevée</option>
                      <option value="basse">Basse</option>
                    </select>
                  </div>
                </div>

                {/* Notifier */}
                <label className="flex items-center gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={notifyByEmail}
                    onChange={(e) => setNotifyByEmail(e.target.checked)}
                    className="accent-[#9B1B5D] w-3.5 h-3.5"
                  />
                  <span className="text-xs font-medium text-slate-600">Notifier par email les collaborateurs</span>
                </label>

                <div className="border-t border-slate-100" />

                {/* Collaborateur */}
                <div className="relative w-full">
                  <label className="block text-xs font-semibold text-slate-500 mb-1">
                    Collaborateur lié à la tâche <span className="text-red-400 font-normal italic">(obligatoire*)</span>
                  </label>
                  <input
                    type="text"
                    value={searchUser}
                    onChange={handleSearchUser}
                    placeholder="Rechercher un utilisateur…"
                    autoComplete="off"
                    className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40 placeholder:text-slate-300"
                  />
                  {userSuggestions.length > 0 && (
                    <ul className="absolute left-0 top-full mt-1 w-full max-h-60 overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg z-20">
                      {userSuggestions.map((user) => (
                        <li
                          key={user.id}
                          onClick={() => selectUser(user)}
                          className="cursor-pointer px-3 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors border-b last:border-b-0"
                        >
                          {user.name} {user.lastName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Chips utilisateurs */}
                <div>
                  {formData.userIds.length === 0 ? (
                    <p className="text-xs text-slate-400 italic">Aucun utilisateur ajouté.</p>
                  ) : (
                    <div className="flex flex-wrap gap-2">
                      {formData.userIds.map((id) => {
                        const user = allUsers.find((u) => u.id === id);
                        return (
                          <div
                            key={id}
                            className="flex items-center gap-2 bg-[#9B1B5D]/10 border border-[#9B1B5D]/20 text-[#9B1B5D] px-3 py-1.5 rounded-full text-sm"
                          >
                            <span>{user?.name || "Utilisateur inconnu"} {user?.lastName || ""}</span>
                            <button
                              type="button"
                              onClick={() => handleRemoveUser(id)}
                              className="text-[#9B1B5D] hover:text-red-500 font-medium transition-colors"
                            >
                              ✕
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ── Détails de la tâche ── */}
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-slate-50 border-b border-slate-200">
                <FileText className="w-4 h-4 text-[#9B1B5D]" />
                <span className="text-sm font-semibold text-slate-700">Détails de la tâche</span>
              </div>
              <div className="p-4 space-y-3">
                <div>
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Titre</label>
                  <input
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder="Titre de la tâche..."
                    required
                    className="h-10 w-full rounded-lg bg-white px-3 text-sm border border-gray-200 outline-none focus:border-[#9B1B5D]/40 transition-all placeholder:text-slate-300"
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-slate-500 mb-1">Statut</label>
                    <select
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                      className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40 text-slate-700"
                    >
                      <option value="">— Statut —</option>
                      <option value="En cours">En cours</option>
                      <option value="Terminer">Terminer</option>
                      <option value="Annuler">Annuler</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-slate-500 mb-1">Type</label>
                    <select
                      name="type"
                      value={formData.type}
                      onChange={handleChange}
                      className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40 text-slate-700"
                    >
                      <option value="">— Type de tâche —</option>
                      <option value="autres">Autres</option>
                      <option value="Preparation">DPA-0</option>
                      <option value="Diligences">Diligences NpMQ & LAB</option>
                      <option value="evenement">Évènement</option>
                      <option value="Verification">Vérification des premiers obligations fiscales</option>
                      <option value="dext">Paramétrage comptabilité/dext</option>
                      <option value="MissionDroitSoc">Mission de droit sociaux</option>
                      <option value="MissionModifSoc">Mission de modification de société</option>
                      <option value="MissionCreation">Mission de création de société</option>
                      <option value="Radiation">Mission de Radiation</option>
                      <option value="SuiviBilan">Suivi Bilan</option>
                      <option value="SuiviSocial">Suivi Social</option>
                      <option value="autresMission">Autres Mission</option>
                      <option value="TraitementComptablePreCompta">
                        Traitement Comptable – Pré-compta
                      </option>
                    </select>
                  </div>
                </div>
                {formData.type === "TraitementComptablePreCompta" && (
                  <div>
                    <label className="block text-xs font-semibold text-slate-500 mb-1">
                      Période concernée <span className="text-red-400 font-normal italic">(obligatoire*)</span>
                    </label>
                    <input
                      type="month"
                      name="periodeMois"
                      value={formData.periodeMois}
                      onChange={handleChange}
                      className="h-10 w-full rounded-lg bg-white px-3 text-sm outline-none transition-all border border-gray-200 focus:border-[#9B1B5D]/40"
                    />
                    <p className="text-xs text-slate-400 italic mt-1">
                      Crée directement un dossier Traitements comptables à l'étape 2 (Pré-compta),
                      affecté au premier collaborateur sélectionné ci-dessus — sans passer par
                      "Arrivée pièces comptables".
                    </p>
                  </div>
                )}
                <div>
                  <label className="block text-xs font-semibold text-slate-500 mb-1">Description</label>
                  <textarea
                    name="commentaire"
                    value={formData.commentaire}
                    onChange={handleChange}
                    placeholder="Description de la tâche..."
                    rows={3}
                    className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm bg-white outline-none focus:border-[#9B1B5D]/40 transition-all resize-none"
                  />
                </div>
              </div>
            </div>

            {/* ── Documents associés ── */}
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <button
                type="button"
                onClick={() => setChaqueAssocieDocument(!ChaqueAssocieDocument)}
                className="w-full flex items-center justify-between px-4 py-2.5 bg-slate-50 hover:bg-slate-100 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <FileText className="w-4 h-4 text-[#9B1B5D]" />
                  <span className="text-sm font-semibold text-slate-700">Documents associés</span>
                  <span className="text-xs text-slate-400 italic">(optionnel)</span>
                </div>
                {ChaqueAssocieDocument ? (
                  <ChevronUp className="w-4 h-4 text-slate-400" />
                ) : (
                  <ChevronDown className="w-4 h-4 text-slate-400" />
                )}
              </button>
              {ChaqueAssocieDocument && (
                <div className="p-4 space-y-3">
                  {[
                    { name: "bilanDocument", label: "Document 1", accept: ".pdf,.docx,.png,.jpg,.jpeg,.webp,.xls,.xlsx" },
                    { name: "identityDocument", label: "Document 2", accept: ".pdf,.docx,.png,.jpg,.jpeg,.webp" },
                    { name: "kbisDocument", label: "Document 3", accept: ".pdf,.png,.jpg,.jpeg" },
                    { name: "statusDocument", label: "Document 4", accept: ".pdf,.docx" },
                    { name: "pieceIdentite", label: "Document 5", accept: ".pdf,.png,.jpg,.jpeg,.webp" },
                  ].map(({ name, label, accept }) => (
                    <div key={name} className="flex items-center justify-between gap-4">
                      <span className="text-xs text-slate-600 w-24 shrink-0">{label}</span>
                      <input
                        type="file"
                        name={name}
                        onChange={handleFileChange}
                        accept={accept}
                        className="text-xs text-slate-500 file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-xs file:font-medium file:bg-[#9B1B5D]/10 file:text-[#9B1B5D] hover:file:bg-[#9B1B5D]/20 cursor-pointer"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </form>

          {/* Pied de page fixe */}
          <div className="shrink-0 flex items-center justify-between px-6 py-4 border-t border-slate-100 bg-white">
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); setShowAddDiv(false); }}
              className="px-6 h-10 border border-slate-200 text-slate-600 text-sm font-medium rounded-lg hover:bg-slate-50 transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading || isFormInvalid}
              onClick={handleSubmit}
              className={`flex items-center gap-2 px-8 h-10 text-white text-sm font-medium rounded-lg shadow-sm shadow-[#9B1B5D]/20 transition-colors ${
                loading || isFormInvalid
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#9B1B5D] hover:bg-[#7A1548]"
              }`}
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  {uploadProgress !== null ? `Envoi du document... ${uploadProgress}%` : "Création en cours..."}
                </>
              ) : (
                <>
                  <Check className="w-4 h-4" />
                  Créer la tâche
                </>
              )}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CreateTodo;
